import { render } from "./ContentBlock.vue?vue&type=template&id=09fc2dc4"
import script from "./ContentBlock.vue?vue&type=script&lang=js"
export * from "./ContentBlock.vue?vue&type=script&lang=js"

import "./ContentBlock.vue?vue&type=style&index=0&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "09fc2dc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09fc2dc4', script)) {
    api.reload('09fc2dc4', script)
  }
  
  module.hot.accept("./ContentBlock.vue?vue&type=template&id=09fc2dc4", () => {
    api.rerender('09fc2dc4', render)
  })

}

script.__file = "src/components/ContentBlock.vue"

export default script